import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
// import { FeedbackGridDataService } from 'common/services/data-services/feedback-grid-data.service';
import { FeedbackModel } from 'common/models/page-models/feedback/feedback-data-model';
import { FeedbackGridMetaModel } from 'common/models/page-models/feedback/feedback-grid-meta-model';
import { FeedbackListingModel } from 'common/models/page-models/feedback/feedback-grid-model';
import { FeedbackGridDataService } from 'common/services/data-services/admin/feedback/feedback-grid-data.service';

@Injectable({
    providedIn: 'root'
})
export class FeedbackGridWidgetService extends GridWidgetService<FeedbackModel, FeedbackListingModel> {
    constructor(protected override  ds: FeedbackGridDataService, protected systemService: SystemService) {
        super(ds);
    }
 
    getMetaModel(): MetaModel {
        const meta = new FeedbackGridMetaModel().getMetaModel();
        return meta;
    }
}